<template>
  <Container type="card-full">
    <div class="search">
      <div class="search_box">
        <div class="searchItem">
          <div class="label">项目编号</div>
          <div class="field">
            <el-input v-model.trim="query.projectcode" clearable ></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">平台编号</div>
          <div class="field">
            <el-input v-model.trim="query.projectno" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">项目名称</div>
          <div class="field">
            <el-input v-model.trim="query.projectname" clearable ></el-input>
          </div>
        </div>
        <!--<div class="searchItem">-->
          <!--<div class="label">状态</div>-->
          <!--<div class="field">-->
            <!--<el-select v-model="query.status" :clearable="true" placeholder="请选择">-->
              <!--<el-option-->
                <!--v-for="item in projectStatusList"-->
                <!--:key="item.value"-->
                <!--:label="item.label"-->
                <!--:value="item.value">-->
              <!--</el-option>-->
            <!--</el-select>-->
          <!--</div>-->
        <!--</div>-->
        <div class="searchItem">
          <div class="search_btn">
            <el-button @click="search">查询</el-button>
          </div>
        </div>
      </div>
    </div>
    <vggrid ref="xGrid" :list="list" tableheight="600" flexname="" :cols="cols"
            :showfooter="false" :showPage="false" :resizable="true"
            :total="query.total" @cellClick="cellClick"  @cellDblClick="viewProject"
      :isOperate="btn.isOperate" :operateBtn="btn.right" @vggridClick="vggridClick"
      >
        <template slot="btn">
            <menu-btn :menuid="menuid" @btnClick="btnClick" @btnmenuclick="btnmenuclick"></menu-btn>
        </template>
    </vggrid>
  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import MenuBtn from "../common/menuBtn"
  import vggrid from '../common/vggrid'
  import dayjs from 'dayjs'
  import utils from '../../assets/js/utils'
  export default {
    name: 'psuConfirmIndex',
    data () {
      return {
        menuid: this.$route.query.menuid,
        list: [],
        btn:{},
        btnLoading: false,
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 50 },
          { field: 'projectcode', fieldtype: 'C', title: '项目编号',calculExpr:'',addNewRowFlg: false, width: 150},
          { field: 'projectno', fieldtype: 'C', title: '平台编号',calculExpr:'',addNewRowFlg: false, width: 150},
          { field: 'projectname', fieldtype: 'C', title: '项目名称',calculExpr:'',addNewRowFlg: false},
          { field: 'prsbmendtime', fieldtype: 'T', title: '报名截止时间',calculExpr:'',addNewRowFlg: false,formatter: ['toDateString', ''], width: 180},
          { field: 'projecttime', fieldtype: 'T', title: '建项时间',calculExpr:'',addNewRowFlg: false,formatter: ['toDateString', 'yyyy-MM-dd'], width: 100},
          { title: '操作 ', width: 100, showOverflow: true,
            slots: {
              default: 'default',
              default: ({row}) => {
                if(dayjs(row.prsbjbegtime).valueOf()>dayjs().valueOf()){
                  return [<vxe-button onClick={this.batchConfirm.bind(this, row)}>审核</vxe-button>]
                } else {
                  return [<vxe-button onClick={this.batchConfirm.bind(this, row)}>查看</vxe-button>]
                }
              }
            }
          }
        ],
        project: {},
        projectStatusList: [],
        query: {
          cosid: this.$store.getters.loginUser.cosid,
          userid: this.$store.getters.loginUser.userid,
          comid: this.$store.getters.loginUser.comid,
          total: 0,
          limit: 20,
          offset: 0
        }
      }
    },
    created () {
      this.$on('SHENPI', () => this.batchConfirm())
      this.$on('CLOSE', () => this.close())
    },
    activated() {
      this.init()
      this.getPageList()
      this.getProjectStatusList()
    },
    mounted () {
    },
    watch: {
    },
    components: {MenuBtn,vggrid},
    methods: {
      async getProjectStatusList () {
        this.projectStatusList = await request({
          url: '/kfgl/syscode/getSysCodeList',
          method: "get",
          params: {syscode: 'projectstatus'}
        })
      },
      btnClick (code) {
        this.$emit(code)
      },
      vggridClick(code,row){
        this.project = row
        this.$emit(code,row)
      },
      btnmenuclick(btn){
        this.btn = btn
      },
      async init() {
        this.query = {
          cosid: this.$store.getters.loginUser.cosid,
          userid: this.$store.getters.loginUser.userid,
          comid: this.$store.getters.loginUser.comid,
          total: 0,
          limit: 20,
          offset: 0}
        this.list = []
        this.btnLoading = false
        this.project = {}
      },
      async close() {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
      },
      async cellClick (row) {
        this.project = row.row
      },
      async viewProject(row) {
        this.project = row.row
        this.$router.push({name: 'psuConfirmForm', params: {projectid: this.project.projectid,innerbtn: this.btn.inner}})
      },
      async pagechange (page) {
        this.query.offset = page.pageSize * (page.currentPage - 1)
        this.query.limit = page.pageSize
        this.getPageList()
      },
      async batchConfirm(row) {
        // console.log(row, 21212)
        // if (!this.project.projectid) {
        //   this.$message.warning('请选择一个项目!')
        //   return
        // }
        this.$router.push({name: 'psuConfirmForm', params: {projectid: row.projectid}})
      },
      search () {
        this.query.offset = 0
        this.getPageList()
      },
      async getPageList () {
        this.loading = true
        this.query.projectstatus=10
        this.query.fromcode = 'bmqr'
        let res = await request({
          method: 'get',
          url: '/xmgl/project/getPageList',
          params: this.query
        })

        console.log(res)
        this.list = res.list
        this.query.total = res.count[0].count
        this.loading = false
      }
    },
    filters: {
    }
  }
</script>
<style lang="scss">

</style>
